module.exports = __webpack_public_path__ + "static/media/6.8c51f7e4.jpeg";